/* eslint-disable react-hooks/exhaustive-deps */
import React, { type ReactElement, useEffect, useRef, useState } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { violationsReportActions } from '../../features';
import ReportModal from '../../features/ViolationsReport/components/ReportModal';
import ReportPreview from '../../features/ViolationsReport/components/ReportPreview';
import useExportStatusPolling from '../../features/ViolationsReport/hooks/use-exportStatusPolling';
import { violationsTabActions } from '../../features/ViolationsTab/data-store/violationsTabSlice';
import type { RootState } from '../../shared/types';

import './Report.css';

/**
 * Layout for the Report page:
 * ECMv6/soddetail/violations/report
 *
 */
function Report(): ReactElement {
  const location = useLocation();
  const dispatch = useDispatch();
  const [showReportModal, setShowReportModal] = useState(false);

  useExportStatusPolling();

  const activeFilters = useSelector(
    (state: RootState) => state.aag.violationsTab.controls.activeFilters
  );
  const hasCleared = useRef(false);

  useEffect(() => {
    batch(() => {
      dispatch(violationsReportActions.setReportError({ state: false }));

      // Clear only violation age filter when navigating to report page (only once)
      if (!hasCleared.current && activeFilters.length > 0) {
        dispatch(violationsTabActions.setActiveFilters(activeFilters));
        hasCleared.current = true;
      }
    });
  }, [location, dispatch, activeFilters]);

  return (
    <>
      <ReportPreview setShowReportModal={setShowReportModal} />
      <ReportModal
        isOpen={showReportModal}
        setIsOpen={setShowReportModal}
        isViewAllReport
      />
    </>
  );
}

export default Report;
